/* eslint-disable react/destructuring-assignment */
/* TODO: enable @Shajansheriff */
import { Space, Table } from 'antd';
import sortBy from 'lodash/sortBy';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/models';
import { ProjectManagerRating } from 'api/reports/csat';
import { Avatar } from 'components/atoms/avatar';
import { Rate } from 'components/atoms/rate';
import { fullName } from 'utils/full-name';
import { Widget } from '../widget';

interface AvgRatingCellProps {
  value: number;
}

const RatingValue = styled.div`
  min-width: 24px;
`;

const AvgRatingCell: FC<AvgRatingCellProps> = ({ value }) => (
  <Space align="center">
    <RatingValue>{String(value?.toPrecision(2))}</RatingValue>
    <Rate disabled value={value} />
  </Space>
);

interface Props {
  data?: ProjectManagerRating[];
  isLoading?: boolean;
}

export const ProjectManagerRatings: FC<Props> = ({
  data,
  isLoading = false,
}) => {
  const COLUMNS = [
    {
      title: <FormattedMessage id="project_managers" />,
      dataIndex: 'projectManager',
      key: 'projectManager',
      render: (value: User) => (
        <Space>
          <Avatar size="small" src={value?.photoUrl} />
          {fullName(value)}
        </Space>
      ),
    },

    {
      title: <FormattedMessage id="csat.average_rating" />,
      dataIndex: 'avg',
      key: 'avg',
      render: (value: number) => <AvgRatingCell value={value} />,
    },
  ];

  return (
    <Widget loading={isLoading}>
      <Table<ProjectManagerRating>
        size="small"
        pagination={false}
        dataSource={data && sortBy(data, 'avg').reverse()}
        columns={COLUMNS}
      />
    </Widget>
  );
};
